import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

export interface ReceiptColumn<T = any> {
    key: string;
    label: string;
    className?: string;
    render?: (row: T) => ReactNode;
}

interface ReceiptTableProps<T = any> {
    columns: ReceiptColumn<T>[];
    data: T[];
    children?: ReactNode;
}

const ReceiptTable = <T extends Record<string, any>>({
    columns = [],
    data = [],
    children,
}: ReceiptTableProps<T>) => {
    const { t } = useTranslation();

    return (
        <div className="request-printed-table text-center p-0 overflow-hidden">
            <div className="table-row table-header">
                {columns.map((col) => (
                    <div key={col.key} className={`table-cell ${col.className || ""}`}>
                        {t(col.label)}
                    </div>
                ))}
            </div>

            {data.map((row, index) => (
                <div key={index} className="table-row">
                    {columns.map((col) => (
                        <div key={col.key} className={`table-cell ${col.className || ""}`}>
                            {col.render ? col.render(row) : row[col.key] ?? "-"}
                        </div>
                    ))}
                </div>
            ))}

            {children}
        </div>
    );
};

export default ReceiptTable;